<div class="container mx-auto px-4 py-6" *transloco="let t">
  <div class="mb-6">
    <h2 class="text-xl font-bold mb-4">{{ t('productGroup.filterTitle') }}</h2>
    <div class="grid grid-cols-1 md:grid-cols-8 gap-4 items-center">
      <input [maxlength]="100" type="text" class="border border-gray-300 rounded-md p-2 w-full md:col-span-6"
        [placeholder]="t('productGroup.namePlaceholder')" [(ngModel)]="filter.name" />

      <select class="border border-gray-300 rounded-md p-2 w-full md:col-span-2" [(ngModel)]="filter.inactive">
        <option value="">{{ t('productGroup.all') }}</option>
        <option [value]="false">{{ t('productGroup.active') }}</option>
        <option [value]="true">{{ t('productGroup.inactive') }}</option>
      </select>

    </div>

    <!-- Botões -->
    <div class="mt-4 flex space-x-4">
      <button (click)="search()" class="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600">
        {{ t('productGroup.search') }}
      </button>

      <button (click)="createProductGroup()" class="bg-green-500 text-white px-4 py-2 rounded-md hover:bg-green-600">
        {{ t('productGroup.createNew') }}
      </button>
    </div>
  </div>

  <!-- Grade de resultados -->
  <div>
    <table class="min-w-full bg-white border">
      <thead>
        <tr class="bg-gray-200 text-left">
          <th class="py-2 px-4 w-2/4">{{ t('productGroup.colName') }}</th>
          <th class="py-2 px-4 w-1/6">{{ t('productGroup.colProducts') }}</th>
          <th class="py-2 px-4 w-1/6">{{ t('productGroup.colActive') }}</th>
          <th class="py-2 px-4 w-1/6">{{ t('productGroup.colDate') }}</th>
          <th class="py-2 px-4 w-1/12">{{ t('productGroup.colActions') }}</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let productGroup of productGroups" class="border-b hover:bg-gray-100">
          <td class="py-2 px-4">{{ productGroup.name }}</td>
          <td class="py-2 px-4">{{ productGroup.productIds.length }}</td>
          <td class="py-2 px-4">
            <span class="px-2 py-1 rounded-full text-sm"
              [ngClass]="!productGroup.inactive ? 'bg-green-200 text-green-800' : 'bg-red-200 text-red-800'">
              {{ (!productGroup.inactive ? 'productGroup.active' : 'productGroup.inactive') | transloco }}
            </span>
          </td>
          <td class="py-2 px-4">{{ productGroup.createdDate | date: 'dd/MM/yyyy' }}</td>
          <!-- Ícone de edição com dropdown -->
          <td class="py-2 px-4 text-center relative">
            <button class="focus:outline-none" (click)="toggleDropdown(productGroup)">
              <i class="fas fa-ellipsis-h"></i>
            </button>
            <div *ngIf="dropdownOpen[productGroup.id]"
              class="absolute right-0 mt-2 py-2 w-48 bg-white rounded-lg shadow-xl z-20">
              <a href="#" (click)="editProductGroup(productGroup.id); $event.preventDefault()"
                class="block px-4 py-2 text-gray-800 hover:bg-gray-200">
                {{ t('productGroup.edit') }}
              </a>
              <a href="#" (click)="inactiveActiveProductGroup(productGroup); $event.preventDefault()"
                class="block px-4 py-2 text-gray-800 hover:bg-gray-200">
                {{ (productGroup.inactive ? 'productGroup.activate' : 'productGroup.deactivate') | transloco }}
              </a>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

  </div>
</div>
